var map = {
	"./footer1.png": 8748,
	"./footer2.png": 3522,
	"./gloriastune.png": 3162,
	"./header.png": 7118,
	"./mockup-avatar.png": 3566,
	"./mockup-cover.png": 4876,
	"./mockup-frame.svg": 2908,
	"./your-room.png": 9412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3553;